import * as React from 'react';
import { BulkDeleteButton } from '../BulkDeleteButton';

export const BulkActionButtons = props => (
  <>
    <BulkDeleteButton {...props} />
  </>
);
